import { useTranslation } from 'react-i18next';
import React, {useState, useEffect} from "react";
import Api from "../../services/Api";
import TabMenu from "../../components/TabMenu/TabMenu";
import AvailabilitySchedule from "./AvailabilitySchedule";
import AvailabilityOther from "./AvailabilityOther";
import AvailabilitySync from "./AvailabilitySync";
import AvailabilitySummary from "./AvailabilitySummary";
import {StrMap} from "../../interfaces/common";


enum tabs {
  SCHEDULE,
  OTHER_SETTINGS,
  SYNC_EXTERNAL_CALENDAR,
  SCHEDULE_SUMMARY
}

export default function Availability() {
  const api = Api.getInstance();
  const translation = useTranslation();
  const { t } = translation;
  const [view, setView] = useState<tabs>(tabs.SCHEDULE);
  const [activeTab, setActiveTab] = useState<number>(0);

  useEffect(() => {
    const oauth_temp = window.localStorage["oauth_temp"]
    if (oauth_temp) {
      const keyVals:StrMap = {}
      for (const pair of oauth_temp.substring(1).split('&')) {
        const [k, v] = pair.split('=');
        keyVals[k] = decodeURIComponent(v);
      }


      if (keyVals['code']) {
        // window.history.replaceState("", document.title, window.location.pathname);
        const state: string = keyVals['state']
        let name = "Google"
        if (state && state.startsWith("Microsoft")) {
          name = "Microsoft"
        }
        const data = {
          email: 'unknown',
          name: name,
          code: keyVals['code'],
        }
        api.post('synced_calendars/set', data).then(() => {
          window.localStorage.removeItem("oauth_temp");
          setView(tabs.SYNC_EXTERNAL_CALENDAR);
          setActiveTab(tabs.SYNC_EXTERNAL_CALENDAR)
        }).catch(response => console.log(response))
      }

    }
  }, [])

  const renderTab = () => {
    if (view === tabs.SCHEDULE) {
      return <AvailabilitySchedule/>
    } else if (view === tabs.OTHER_SETTINGS) {
      return <AvailabilityOther />
    } else if (view === tabs.SCHEDULE_SUMMARY) {
      return <AvailabilitySummary />
    } else {
      return <AvailabilitySync />
    }
  }

  return (
    <div className="main-content">
      <h1 className="text-2xl font-medium text-white  my-4 desktop:my-6">
        {t('availability')}
      </h1>
      <TabMenu items={[
        {title: t('schedule'), callback: () => setView(tabs.SCHEDULE)},
        {title: t('other-settings'), callback: () => setView(tabs.OTHER_SETTINGS)},
        {title: t('sync-external-calendar'), callback: () => setView(tabs.SYNC_EXTERNAL_CALENDAR)},
        {title: t('summary'), callback: () => setView(tabs.SCHEDULE_SUMMARY)},
      ]}
               active={activeTab}
      />

      {renderTab()}
    </div>
  );
};